import { CreateRoleFormValues } from './types';

export const CREATE_ROLE_STEP_IDS = {
  roleDetails: 'roleDetails',
  contents: 'contents',
  modifiers: 'modifiers',
} as const;

export type CreateRoleStepId =
  (typeof CREATE_ROLE_STEP_IDS)[keyof typeof CREATE_ROLE_STEP_IDS];

export interface CreateRoleStepConfig {
  id: CreateRoleStepId;
  label: string;
  sectionTitle: string;
  fields: Array<keyof CreateRoleFormValues>;
}

export const CREATE_ROLE_STEPS: CreateRoleStepConfig[] = [
  {
    id: CREATE_ROLE_STEP_IDS.roleDetails,
    label: 'Role details',
    sectionTitle: 'Name',
    fields: ['name', 'description', 'teamId'],
  },
  {
    id: CREATE_ROLE_STEP_IDS.contents,
    label: 'Contents',
    sectionTitle: 'Contents',
    fields: ['contents'],
  },
  {
    id: CREATE_ROLE_STEP_IDS.modifiers,
    label: 'Modifiers',
    sectionTitle: 'Modifiers',
    fields: [],
  },
];

export const CREATE_ROLE_STEP_LABELS = CREATE_ROLE_STEPS.map(step => step.label);

export function getCreateRoleStepFields(
  stepIndex: number,
): Array<keyof CreateRoleFormValues> {
  return CREATE_ROLE_STEPS[stepIndex]?.fields ?? [];
}
